export default "__VITE_ASSET__CPFU07EA__"